import {ContentCursor} from "../services/content/content.cursor";
import {ContentService} from "../services/content/content.service";
import {ContentViewComponent} from "../content/content-view.component";
import {WordWallViewComponent} from "../wordwall/wordwall-view.component";
import {CountdownComponent} from "./countdown.component";
import {GlossaryComponent} from "../glossary/glossary.component";
import {GlossaryService} from "../services/glossary/glossary.service";
import {NgModule} from "@angular/core";
import {PointService} from "../services/points/points.service";
import {PreviewService} from "../services/reading/preview.service";
import {QuestionComponent} from "../questions/question.component";
import {QuestionService} from "../services/question/question.service";
import {QuizComponent} from "../questions/quiz.component";
import {QuizService} from "../services/quiz/quiz.service";
import {ScrollService} from "../services/scroll/scroll.service";
import {ReadMyRecordingService} from "../services/reading/readmyrecording.service";
import {ReadToMeService} from "../services/reading/readtome.service";
import {ReadingComponent} from "./reading.component";
import {RecordingComparisonService} from "../services/recording/recording-comparison.service";
import {RecordingService} from "../services/recording/recording.service";
import {WordWallRecordingService} from "../services/recording/wordwall.recording.service";
import {DebugModalComponent} from "../debug/debug.modal.component";
import {RuntimeTestModalComponent} from "../services/runtimetest/runtimetest.modal.component";
import {RuntimeTestService} from "../services/runtimetest/runtimetest.service";
import {StepComponent} from "../step/step.component";
import {StepService} from "../services/step/step.service";
import {StepCircleComponent} from "../step/step-circle.component";
import {UserModelService} from "../services/usermodel/usermodel.service";
import {ProgressionComponent} from "../notification/progression.component";
import {readingRouting} from "./reading.routes";
import {CommonModule} from "@angular/common";
import {TranslateModule, TranslateLoader} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import {PipelineModule} from "../pipeline/pipeline.module";
import {WordColorComponent} from "./word-color.component";
import {DisplayAgent} from "../services/browser/display.agent";
import {StepStateUpdater} from "../services/step/step-state";
import {UserProgress} from "../services/usermodel/user-progress";
import {StepIconGenerator} from "../reports/step-icon-generator";
import {GAEventService} from "../services/analytics/GAEventServce";
import {ClientConfiguration} from "../services/configuration/client.config";
import {BookIntroComponent} from "./book.intro.component";
import {RaVersion} from "../services/configuration/ra.version";
import {ExitButtonEnabler} from "../nav/exit-button.enabler";
import {AnswerPresentationService} from "../services/question/answer.presentation.service";
import {HttpClient} from "@angular/common/http";

export function HttpLoaderFactory(http: HttpClient, config:ClientConfiguration): TranslateHttpLoader {
    return new TranslateHttpLoader(http, config.rootPath + "i18n/", ".json" + RaVersion.full);
}

@NgModule({
              bootstrap: [
                  ReadingComponent
              ],
              declarations: [
                  BookIntroComponent,
                  ContentViewComponent,
                  CountdownComponent,
                  DebugModalComponent,
                  GlossaryComponent,
                  ProgressionComponent,
                  QuestionComponent,
                  QuizComponent,
                  ReadingComponent,
                  RuntimeTestModalComponent,
                  StepCircleComponent,
                  StepComponent,
                  WordColorComponent,
                  WordWallViewComponent
              ],
              imports: [
                  BrowserModule,
                  FormsModule,
                  CommonModule,
                  TranslateModule.forRoot({
                      loader: {
                          provide: TranslateLoader,
                          useFactory: HttpLoaderFactory,
                          deps: [HttpClient, ClientConfiguration]
                      }
                  }),
                  PipelineModule,
                  readingRouting
              ],
              providers: [
                  AnswerPresentationService,
                  ContentCursor,
                  ContentService,
                  DisplayAgent,
                  ExitButtonEnabler,
                  GlossaryService,
                  GAEventService,
                  PreviewService,
                  QuestionService,
                  QuizService,
                  ReadMyRecordingService,
                  ReadToMeService,
                  RecordingComparisonService,
                  RecordingService,
                  WordWallRecordingService,
                  RuntimeTestService,
                  StepService,
                  UserModelService,
                  PointService,
                  ScrollService,
                  StepIconGenerator,
                  StepStateUpdater,
                  UserProgress
              ]
          })
export class ReadingModule {
}
